module.exports = __webpack_public_path__ + "static/img/5.547fd38.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/11/zh/5.png
// module id = mUYt
// module chunks = 0